import VueAppContainer from "@/entry/VueAppContainer.js"
import PublicToolDemoApp from "@/core/modules/coach/Resources/CoachingTools/GenericTools/PublicDemo/PublicToolDemoApp.vue"

if(!VueAppContainer.App){
	VueAppContainer.App = PublicToolDemoApp
}
